import React from 'react';
import ButtonDesigned from '../../../Buttons/ButtonDesigned';
import { useDropzone } from 'react-dropzone';

interface Props {
  dropzoneConfig: any;
  onExit: () => void;
}
export const DropOrBrowse: React.FC<Props> = ({ onExit, dropzoneConfig }): React.ReactNode => {
  const multiFileDropConfig = {
    disabled: false,
    onDrop: (files: any[]) => dropzoneConfig.onDrop(files).then(onExit),
  };

  const { getRootProps, getInputProps } = useDropzone(multiFileDropConfig);

  return (
    <div
      {...getRootProps()}
      className="flex flex-col gap-6 bg-white overflow-hidden border-dashed rounded border-1 border-gray-110 items-center p-4 w-80 h-80"
    >
      <input {...getInputProps()} />
      <img src="/assets/icons/red/create-order.svg" />
      <p className={` text-center text-xl text-red-200`}>Drag and Drop file</p>
      <div>
        <p className="text-center text-sm text-secondary_text">or</p>
        <p className="text-center text-sm text-secondary_text">click the Browse button below</p>
      </div>

      <ButtonDesigned onButtonClick={() => {}} style="outline">
        Browse
      </ButtonDesigned>
    </div>
  );
};
